module.exports = __webpack_public_path__ + "img/music-slash.cb42b92e.svg";